import React from 'react';
import styles from './style.scss';

const SquareTabs = props => {
    const {
        label,
        isSelected
    } = props;

    return (
        <div className={`${styles['tab']} ${isSelected ? styles['selected'] : ''}`} onClick={props.onClick}>
            {label}
        </div>
    )
};

export default SquareTabs;